import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.action.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
    blue: {
        rectColour: CATEGORIES.action.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

defineBlock({
    type: 'tt_motor',
    colour: CATEGORIES.action.color,
    tooltip: 'TTモーターを制御します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/tt_motor.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('TTモーター', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: 'で' },
                {
                    type: 'dropdown',
                    name: 'STATE',
                    options: [
                        { value: 'FORWARD', label: '回る' },
                        { value: 'REVERSE', label: '逆に回る' },
                        { value: 'STOP', label: '回らない' },
                    ],
                },
                { type: 'label', text: ' ' },
            ],
        },
    ],
});
